<template>
    <div
        class="lms__superadmin_users_profile_edit_learninghistory_external_grid_item"
    >
        <div class="columns">
            <div class="column">
                <div class="lms__superadmin_users_profile_edit_learninghistory_external_grid_item_content">
                    <h2 class="lms__superadmin_users_profile_edit_learninghistory_external_grid_item_content_title">{{ courseName }}</h2>
                    <div class="lms__superadmin_users_profile_edit_learninghistory_external_grid_item_content_details">
                        <component-text :size="'small'">Completed {{ courseCompletionDate }}</component-text>
                        <component-text v-if="courseProvider" :size="'small'">Provider - {{ courseProvider }}</component-text>
                        <component-text v-if="courseAccreditation" :size="'small'">Accreditation - {{ courseAccreditation }}</component-text>
                    </div>
                </div>
                <div class="lms__superadmin_users_profile_edit_learninghistory_external_grid_item_actions">
                    <component-button
                        v-if="courseCertificateUrl"
                        :name="`lms-superadmin-users-profile-edit-learning-history-grid-item-actions-certificate`"
                        :theme="'default'"
                        :align="'left'"
                        :icon="true"
                        :icon-name="'award'"
                        @click="courseCertificateDownload"
                    ></component-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime } from '@/functions'

export default {
  name: 'lms-superadmin-users-profile-edit-learning-history-external-grid-item',
  components: { ComponentText, ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    courseName () {
      return this.item.courseName
    },
    courseCompletionDate () {
      return this.item.completionDate ? toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.completionDate)) : '-'
    },
    courseProvider () {
      return this.item.provider
    },
    courseAccreditation () {
      return this.item.accreditation
    },
    courseCertificateUrl () {
      return this.item.certificateId ? `${api.files}/file/${this.item.certificateId}` : undefined
    }
  },
  methods: {
    courseCertificateDownload () {
      this.$store.dispatch('ebsCertificateDownload', { name: this.courseName, url: this.courseCertificateUrl })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersprofileeditlearninghistoryexternallistgriditem.scss";
</style>
